import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME  } from 'src/reducers/clients/clients';
import { setItem } from 'src/reducers/common/itemReducer';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_SETTINGS, COMPANY_EDIT } from 'src/constants/EndpointUrls';
import scrollSpy, { AnchorTarget } from 'jbc-front/components/ScrollSpy';
import { Anchor } from 'src/components';
import { Panel, Headding, Item } from 'src/components/PrimaryPanel';
import Affix from 'jbc-front/components/Affix';
import ListGroup from 'jbc-front/components/ListGroup';
import { Edit } from 'jbc-front/components/icons';
import BasicInfoSectionShow from './components/BasicInfoSectionShow';
import BranchInfoSectionShow from './components/BranchInfoSectionShow';
import ImageSectionShow from './containers/ImageSectionShow';
import { concatParamsToUrl } from 'src/utils/Http';
import styles from './ShowCompany.scss';
import { useTranslation } from 'react-i18next';

const CompanySideNavi = ({ current }) => {
  const { t } = useTranslation();
  return (
    <div className="l-flex6-sub">
      <Affix offset={209} className={styles.sideNavi}>
        <ListGroup>
          <Anchor name="CompanyInformation" current={current}>
            {t('features.Clients.ShowCompany.office_information')}
          </Anchor>
          <Anchor name="BranchInformation" current={current}>
            {t('features.Clients.ShowCompany.branch_information')}
          </Anchor>
          <Anchor name="CompanyImage" current={current}>
            {t('features.Clients.ShowCompany.image_information')}
          </Anchor>
        </ListGroup>
      </Affix>
    </div>
  );
};

const CompanyMainContent = ({ editUrl }) => {
  const { t } = useTranslation();
  return (
    <div className="l-flex6-main">
      <div>
        <Panel>
          <AnchorTarget name="CompanyInformation" />
          <a href={editUrl}>
            <Headding icon={<Edit icon={16} />}>{t('features.Clients.ShowCompany.office_information')}</Headding>
          </a>
          <Item>
            <BasicInfoSectionShow />
          </Item>
        </Panel>
        <Panel>
          <AnchorTarget name="BranchInformation" />
          <a href={editUrl}>
            <Headding icon={<Edit icon={16} />}>{t('features.Clients.ShowCompany.branch_information')}</Headding>
          </a>
          <Item>
            <BranchInfoSectionShow />
          </Item>
        </Panel>
        <Panel>
          <AnchorTarget name="CompanyImage" />
          <a href={editUrl}>
            <Headding icon={<Edit icon={16} />}>{t('features.Clients.ShowCompany.image_information')}</Headding>
          </a>
          <Item>
            <ImageSectionShow />
          </Item>
        </Panel>
      </div>
    </div>
  );
};

const ShowCompanyView = scrollSpy(
  ({ editUrl, current }) => {
    const { t } = useTranslation();
    return (
      <div>
        <div className={`${styles.wrap} l-wrap-xl l-contents-wrap`}>
          <div className="u-mb20">
            <BreadCrumb>
              <BreadCrumb.Item label={t('features.Clients.ShowCompany.setting')} path={CLIENT_SETTINGS} />
              <BreadCrumb.Item label={t('features.Clients.ShowCompany.office_information')} />
            </BreadCrumb>
          </div>
        </div>

        <div className={styles.head}>
          <div className={styles.name}>{t('features.Clients.ShowCompany.office_information')}</div>
        </div>

        <div className="l-flex">
          <CompanySideNavi {...{ current }} />
          <CompanyMainContent {...{ editUrl }} />
        </div>
      </div>
    )
  }
);

const ShowCompany = ({ dispatch, values }) => {
  dispatch(setItem(REDUCER_NAME, values));
  const editUrl = concatParamsToUrl(COMPANY_EDIT, { id: values.client.id });
  return <ShowCompanyView {...{editUrl}} />
}

export default connect()(ShowCompany);